import { Text } from '@loomhq/lens';
import autosize from 'autosize';
import cn from 'classnames';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { HELP_CHANGE_TITLE } from 'constants/feature-tour';
import { KEY_ENTER } from 'constants/keyCodes';
import { isChildOfParentClass } from 'utilities/dom';

import * as validate from 'validate';

import ActionDot, {
  OUTSIDE_LEFT_CENTER,
} from 'components/ui-components/action-dot';

import styles from './styles.module.less';

class TitleBar extends Component {
  state = {
    new_title: null,
    should_select_input: false,
    title_initial_focus: false,
    title_focused: false,
    content_type: 'video',
  };

  render() {
    const { titleTourTipIsActive, userCanEdit } = this.props;

    const contentType = this.props.video ? 'video' : 'screenshot';
    const content = this.props[contentType];

    if (content.name === null) {
      return <div className={cn(styles.shareTitleBar, styles.empty)} />;
    }

    const { new_title: newTitle, title_focused: titleFocused } = this.state;

    const title = content.name || this.getDefaultTitleName();

    return (
      <div
        className={cn(styles.shareTitleBar, styles[contentType])}
        ref={titleBar => (this.titleBar = titleBar)}
      >
        {titleTourTipIsActive && <ActionDot position={OUTSIDE_LEFT_CENTER} />}
        <textarea
          className={cn(
            styles.shareTitleBarInput,
            !titleFocused ? styles.hidden : ''
          )}
          ref={this.updateInputRef}
          value={newTitle || ''}
          rows={1}
          maxLength={validate.MAX_VIDEO_NAME_LENGTH}
          onBlur={this.handleInputBlur}
          onChange={this.handleNewTitleUpdate}
          onKeyPress={this.handleTitleKeyPress}
        />
        <Text
          size="xxlarge"
          className={cn(
            styles.shareTitle,
            userCanEdit ? styles.editable : '',
            titleFocused ? styles.hidden : ''
          )}
          onClick={userCanEdit ? this.focusTitle : null}
        >
          {title}
        </Text>
      </div>
    );
  }

  updateInputRef = ref => {
    this.input = ref;
    autosize(ref);
  };

  updateMouseDown = e => {
    this.lastElementClicked = e.target;
  };

  updateMouseUp = () => {
    this.lastElementClicked = null;
  };

  componentDidUpdate(prevProps) {
    const {
      new_title: newTitle,
      should_select_input: shouldSelectInput,
    } = this.state;

    if (this.props.shouldFocusTitle && !this.state.title_initial_focus) {
      this.setState({ title_initial_focus: true });

      return this.focusTitle();
    }

    if (newTitle != null && shouldSelectInput && this.input != null) {
      this.input.select();
      this.setState({ should_select_input: false }, () => {
        autosize.update(this.input);
      });
    }

    const titleTourStateChanged =
      prevProps.titleTourTipIsActive !== this.props.titleTourTipIsActive;

    const shouldFocusTitle =
      (this.props.selfExploreTour && !prevProps.selfExploreTour) ||
      (this.props.titleTourTipIsActive && titleTourStateChanged);

    if (shouldFocusTitle) {
      this.focusTitle();
    }
  }

  componentDidMount() {
    const contentType = this.props.video ? 'video' : 'screenshot';

    this.setState({ content_type: contentType });

    if (this.props.shouldFocusTitle && !this.state.title_initial_focus) {
      this.setState({ title_initial_focus: true });

      this.focusTitle();
    }

    document.addEventListener('mousedown', this.updateMouseDown, false);
    document.addEventListener('mouseup', this.updateMouseUp, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.updateMouseDown);
    document.removeEventListener('mouseup', this.updateMouseUp);
  }

  getDefaultTitleName() {
    const { content_type: contentType } = this.state;

    return moment(this.props[contentType].createdAt).format(
      'hh:mm A - MM/DD/YY'
    );
  }

  focusTitle = () => {
    if (this.state.title_focused) {
      return;
    }

    const { content_type: contentType } = this.state;
    const name = this.props[contentType].name || this.getDefaultTitleName();

    this.setState({
      new_title: name,
      title_focused: true,
      should_select_input: true,
    });
  };

  handleInputBlur = () => {
    const { new_title: newTitle, title_focused: titleFocused } = this.state;

    if (!titleFocused) {
      return;
    }

    // https://stackoverflow.com/a/11544766/696130
    const blurWithinTitleBar = isChildOfParentClass(
      this.lastElementClicked,
      `shareTitleBar`,
      10
    );

    if (blurWithinTitleBar) {
      return;
    }

    this.props.onTitleUpdate(newTitle);
    this.setState({
      new_title: null,
      title_focused: false,
      should_select_input: false,
    });
  };

  handleNewTitleUpdate = e => {
    const noNewlines = e.target.value.replace(/\n/g, ' ');
    const noLeadingSpaces = noNewlines.trimLeft();

    this.setState({ new_title: noLeadingSpaces });
  };

  handleTitleKeyPress = e => {
    if (!KEY_ENTER.includes(e.key)) {
      return;
    }

    const { new_title: newTitle } = this.state;

    this.props.onTitleUpdate(newTitle);
    this.setState({
      new_title: null,
      title_focused: false,
      should_select_input: false,
    });
  };
}

const mapStateToProps = state => {
  const { currentTour, tourOpenAndActive, selfExploreTour } = state.featureTour;

  const titleTourTipIsActive =
    currentTour === HELP_CHANGE_TITLE && tourOpenAndActive;

  return {
    titleTourTipIsActive,
    selfExploreTour,
  };
};

export default connect(mapStateToProps)(TitleBar);
